// Debug component to check authentication state
import React from 'react';
import { useSelector } from 'react-redux';
import { CombinedState } from 'reducers';

const DebugAuth: React.FC = () => {
    const auth = useSelector((state: CombinedState) => state.auth);

    // Only show in development mode
    if (process.env.NODE_ENV !== 'development') {
        return null;
    }

    return (
        <div style={{
            position: 'fixed',
            top: '10px',
            right: '10px',
            background: '#f0f0f0',
            padding: '10px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            fontSize: '12px',
            zIndex: 9999,
            maxWidth: '300px',
        }}>
            <h4>Auth Debug Info:</h4>
            <div><strong>Initialized:</strong> {String(auth.initialized)}</div>
            <div><strong>Fetching:</strong> {String(auth.fetching)}</div>
            <div><strong>User ID:</strong> {auth.user?.id || 'null'}</div>
            <div><strong>Username:</strong> {auth.user?.username || 'null'}</div>
            <div><strong>Email:</strong> {auth.user?.email || 'null'}</div>
            <div><strong>IsVerified:</strong> {String(auth.user?.isVerified)}</div>
            <div><strong>IsActive:</strong> {String(auth.user?.isActive)}</div>
            <div><strong>Groups:</strong> {auth.user?.groups?.join(', ') || 'null'}</div>
        </div>
    );
};

export default DebugAuth;